import Evaporate from 'evaporate'
import AWS from 'aws-sdk/global'
import NrSentry from '../utils/nr_sentry'
import API from '../vue_shared/api.js'

export default {
  data() {
    return {
      s3UploadConfig: null,
      evaporate: null
    }
  },
  mounted() {
    API.getS3UploadConfig().then((response) => {
      this.s3UploadConfig = response.data
      this.setupEvaporateFileUploader(response.data)
    })
  },
  methods: {
    setupEvaporateFileUploader(s3UploadConfig) {
      Evaporate.create({
        aws_key: s3UploadConfig.multipart_upload_key_id, // Required
        bucket: s3UploadConfig.bucket, // Required
        awsRegion: s3UploadConfig.aws_region, // Defaults to us-east-1
        signerUrl: '/aws_signature', // Required
        awsSignatureVersion: '4',
        // partSize - 20 MB per part. AWS's 10,000 part maximum means max upload size is 195 GB.
        partSize: 20 * 1024 * 1024,
        sendCanonicalRequestToSignerUrl: true,
        onlyRetryForSameFileName: true,
        computeContentMd5: true,
        mockLocalStorage: true,
        cryptoMd5Method: (data) => {
          return AWS.util.crypto.md5(data, 'base64')
        },
        cryptoHexEncodedHash256: (data) => {
          return AWS.util.crypto.sha256(data, 'hex')
        }
      })
        .then((evaporate) => {
          // set state so we know Evaporate.js is ready to upload docs to s3
          this.evaporate = evaporate
        })
        .catch((e) => {
          const nrError = new Error('Evaporate.create failed', {
            cause: e
          })
          NrSentry.captureError(nrError)
        })
    }
  }
}
